export const ADVANCED_BASED_FILTER_FIELDS = Object.freeze({
  survey: Object.freeze({
    field: 'survey',
    label: 'Survey',
    icon: 'filter',
    comparison: 'is',
  }),
  choiceValue: Object.freeze({
    field: 'choice_value',
    label: 'Rating value',
    icon: 'smile',
    comparison: 'is',
  }),
  sentiment: Object.freeze({
    field: 'sentiment',
    label: 'Sentiment',
    icon: 'smile',
    comparison: 'is',
  }),
  topic: Object.freeze({
    field: 'topic',
    label: 'Topic',
    icon: 'far fa-chart-network',
    comparison: 'is',
  }),
  topicGroup: Object.freeze({
    field: 'topic.group',
    label: 'Topic group',
    icon: 'far fa-chart-network',
    comparison: 'is',
  }),
  topicSentiment: Object.freeze({
    field: 'topic.sentiment',
    label: 'Topic sentiment',
    icon: 'far fa-chart-network',
    comparison: 'is',
  }),
  topicPairSentiment: Object.freeze({
    field: 'topic.pair.sentiment',
    label: 'Topic + sentiment',
    icon: 'far fa-chart-network',
    comparison: 'is',
  }),
  metric: Object.freeze({
    field: 'metric',
    label: 'Metric',
    icon: 'chart line',
    comparison: 'is',
  }),
  comment: Object.freeze({
    field: 'comment',
    label: 'Comment',
    icon: 'far fa-magnifying-glass',
    comparison: 'is',
  }),
  ticketId: Object.freeze({
    field: 'ticket_id',
    label: 'Ticket ID',
    icon: 'far fa-ticket',
    comparison: 'is',
  }),
  emailEvent: Object.freeze({
    field: 'email_event',
    label: 'Email event',
    icon: 'far fa-paper-plane',
    comparison: 'is',
  }),
  teamMember: Object.freeze({
    field: 'team_member',
    label: 'Team member name',
    icon: 'far fa-user-headset',
    comparison: 'is',
  }),
  teamMemberEmail: Object.freeze({
    field: 'team_member.email',
    label: 'Team member email',
    icon: 'far fa-user-headset',
    comparison: 'is',
  }),
  teamMemberId: Object.freeze({
    field: 'team_member.id',
    label: 'Team member external ID',
    icon: 'far fa-user-headset',
    comparison: 'is',
  }),
  teamMemberGroup: Object.freeze({
    field: 'team_member.group',
    label: 'Team member group',
    icon: 'far fa-user-headset',
    comparison: 'is',
  }),
  collaborator: Object.freeze({
    field: 'collaborator',
    label: 'Collaborator',
    icon: 'far fa-user-headset',
    comparison: 'is',
  }),
  customer: Object.freeze({
    field: 'customer',
    label: 'Customer name',
    icon: 'far fa-user',
    comparison: 'is',
  }),
  customerEmail: Object.freeze({
    field: 'customer.email',
    label: 'Customer email',
    icon: 'far fa-user',
    comparison: 'is',
  }),
  customerTag: Object.freeze({
    field: 'customer.tag',
    label: 'Customer Tag',
    icon: 'tag',
    comparison: 'is',
  }),
  company: Object.freeze({
    field: 'company',
    label: 'Company',
    icon: 'building',
    comparison: 'is',
  }),
  ip: Object.freeze({
    field: 'ip',
    label: 'IP address',
    icon: 'street view',
    comparison: 'is',
  }),
  tag: Object.freeze({
    field: 'tag',
    label: 'Tag',
    icon: 'tag',
    comparison: 'is',
  }),
  source: Object.freeze({
    field: 'source',
    label: 'Source',
    icon: 'filter',
    comparison: 'is',
  }),
  language: Object.freeze({
    field: 'language',
    label: 'Language',
    icon: 'far fa-globe',
    comparison: 'is',
  }),
  published: Object.freeze({
    field: 'published',
    label: 'Published',
    icon: 'far fa-bullhorn',
    comparison: 'has_any_value',
    filters: Object.freeze([Object.freeze({ value: true })]),
  }),
  attachment: Object.freeze({
    field: 'attachment',
    label: 'Attachment',
    icon: 'paperclip',
    comparison: 'has_any_value',
    filters: Object.freeze([Object.freeze({ value: true })]),
  }),
})

const createField = (field) => ({ ...field })

export const getBaseFilterSurveyDashboardOptions = () => [
  createField(ADVANCED_BASED_FILTER_FIELDS.sentiment),
  createField(ADVANCED_BASED_FILTER_FIELDS.topic),
  createField(ADVANCED_BASED_FILTER_FIELDS.topicGroup),
  createField(ADVANCED_BASED_FILTER_FIELDS.topicSentiment),
  createField(ADVANCED_BASED_FILTER_FIELDS.topicPairSentiment),
  createField(ADVANCED_BASED_FILTER_FIELDS.company),
  createField(ADVANCED_BASED_FILTER_FIELDS.emailEvent),
  createField(ADVANCED_BASED_FILTER_FIELDS.teamMember),
  createField(ADVANCED_BASED_FILTER_FIELDS.teamMemberEmail),
  createField(ADVANCED_BASED_FILTER_FIELDS.teamMemberId),
  createField(ADVANCED_BASED_FILTER_FIELDS.teamMemberGroup),
  createField(ADVANCED_BASED_FILTER_FIELDS.customer),
  createField(ADVANCED_BASED_FILTER_FIELDS.customerEmail),
  createField(ADVANCED_BASED_FILTER_FIELDS.ip),
  createField(ADVANCED_BASED_FILTER_FIELDS.tag),
  createField(ADVANCED_BASED_FILTER_FIELDS.customerTag),
  createField(ADVANCED_BASED_FILTER_FIELDS.source),
  createField(ADVANCED_BASED_FILTER_FIELDS.language),
]

export const getBaseFilterCustomDashboardOptions = () => [
  createField(ADVANCED_BASED_FILTER_FIELDS.survey),
  createField(ADVANCED_BASED_FILTER_FIELDS.sentiment),
  createField(ADVANCED_BASED_FILTER_FIELDS.topic),
  createField(ADVANCED_BASED_FILTER_FIELDS.topicGroup),
  createField(ADVANCED_BASED_FILTER_FIELDS.topicSentiment),
  createField(ADVANCED_BASED_FILTER_FIELDS.topicPairSentiment),
  createField(ADVANCED_BASED_FILTER_FIELDS.company),
  createField(ADVANCED_BASED_FILTER_FIELDS.ticketId),
  createField(ADVANCED_BASED_FILTER_FIELDS.emailEvent),
  createField(ADVANCED_BASED_FILTER_FIELDS.teamMember),
  createField(ADVANCED_BASED_FILTER_FIELDS.teamMemberEmail),
  createField(ADVANCED_BASED_FILTER_FIELDS.teamMemberId),
  createField(ADVANCED_BASED_FILTER_FIELDS.teamMemberGroup),
  createField(ADVANCED_BASED_FILTER_FIELDS.collaborator),
  createField(ADVANCED_BASED_FILTER_FIELDS.customer),
  createField(ADVANCED_BASED_FILTER_FIELDS.customerEmail),
  createField(ADVANCED_BASED_FILTER_FIELDS.ip),
  createField(ADVANCED_BASED_FILTER_FIELDS.tag),
  createField(ADVANCED_BASED_FILTER_FIELDS.customerTag),
  createField(ADVANCED_BASED_FILTER_FIELDS.source),
  createField(ADVANCED_BASED_FILTER_FIELDS.language),
]

export const getBaseFilterFeedbackOptions = () => [
  createField(ADVANCED_BASED_FILTER_FIELDS.survey),
  createField(ADVANCED_BASED_FILTER_FIELDS.choiceValue),
  createField(ADVANCED_BASED_FILTER_FIELDS.sentiment),
  createField(ADVANCED_BASED_FILTER_FIELDS.topic),
  createField(ADVANCED_BASED_FILTER_FIELDS.topicGroup),
  createField(ADVANCED_BASED_FILTER_FIELDS.topicSentiment),
  createField(ADVANCED_BASED_FILTER_FIELDS.topicPairSentiment),
  createField(ADVANCED_BASED_FILTER_FIELDS.metric),
  createField(ADVANCED_BASED_FILTER_FIELDS.comment),
  createField(ADVANCED_BASED_FILTER_FIELDS.published),
  createField(ADVANCED_BASED_FILTER_FIELDS.attachment),
  createField(ADVANCED_BASED_FILTER_FIELDS.ticketId),
  createField(ADVANCED_BASED_FILTER_FIELDS.emailEvent),
  createField(ADVANCED_BASED_FILTER_FIELDS.teamMember),
  createField(ADVANCED_BASED_FILTER_FIELDS.teamMemberEmail),
  createField(ADVANCED_BASED_FILTER_FIELDS.teamMemberId),
  createField(ADVANCED_BASED_FILTER_FIELDS.teamMemberGroup),
  createField(ADVANCED_BASED_FILTER_FIELDS.collaborator),
  createField(ADVANCED_BASED_FILTER_FIELDS.customer),
  createField(ADVANCED_BASED_FILTER_FIELDS.customerEmail),
  createField(ADVANCED_BASED_FILTER_FIELDS.company),
  createField(ADVANCED_BASED_FILTER_FIELDS.ip),
  createField(ADVANCED_BASED_FILTER_FIELDS.tag),
  createField(ADVANCED_BASED_FILTER_FIELDS.customerTag),
  createField(ADVANCED_BASED_FILTER_FIELDS.source),
  createField(ADVANCED_BASED_FILTER_FIELDS.language),
]

export const getBaseFilterReportOptions = () => [
  createField(ADVANCED_BASED_FILTER_FIELDS.survey),
  createField(ADVANCED_BASED_FILTER_FIELDS.choiceValue),
  createField(ADVANCED_BASED_FILTER_FIELDS.sentiment),
  createField(ADVANCED_BASED_FILTER_FIELDS.ticketId),
  createField(ADVANCED_BASED_FILTER_FIELDS.emailEvent),
  createField(ADVANCED_BASED_FILTER_FIELDS.teamMember),
  createField(ADVANCED_BASED_FILTER_FIELDS.teamMemberEmail),
  createField(ADVANCED_BASED_FILTER_FIELDS.teamMemberId),
  createField(ADVANCED_BASED_FILTER_FIELDS.teamMemberGroup),
  createField(ADVANCED_BASED_FILTER_FIELDS.customer),
  createField(ADVANCED_BASED_FILTER_FIELDS.customerEmail),
  createField(ADVANCED_BASED_FILTER_FIELDS.company),
  createField(ADVANCED_BASED_FILTER_FIELDS.ip),
  createField(ADVANCED_BASED_FILTER_FIELDS.tag),
  createField(ADVANCED_BASED_FILTER_FIELDS.customerTag),
  createField(ADVANCED_BASED_FILTER_FIELDS.source),
  createField(ADVANCED_BASED_FILTER_FIELDS.language),
]



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/hooks/useFilterOptions/constants.js